// extracted by mini-css-extract-plugin
export default {"top":"CraneBooking_top__5BseV","box":"CraneBooking_box__7HOlI","addButton":"CraneBooking_addButton__K5+VL"};